export default "__VITE_ASSET__BbDTyUHh__"